var bindPostalCodeLookup = function ($countries, $postCode, $area, $city, modelData, formData, selectFn, resetFn) {

    var allCountries = modelData.Countries || [];
    var selectedCountry = formData ? formData.Country || "" : "";

    if ($(".postal-code-areas", $countries.closest(".x-control")).length > 0) {
        $(".postal-code-areas", $countries.closest(".x-control")).remove();

        $area.removeClass('disabled');
        $area.prop('oncontextmenu', '');
        $area.prop('onkeypress', '');

        $area.unbind("onAreaClick");
        $area.unbind("onAreaKeyDown");

        $area.unbind("contextmenu");
        $postCode.unbind("onPostCodeKeyUp");

    }

    var $postalCodeAreasResults = $('<div />').addClass('postal-code-areas');
    //$postalCodeAreasResults.hide();
    $area.parent().append($postalCodeAreasResults);
    //$area.after($postalCodeAreasResults);

    $postCode.prop('autocomplete', 'password');
    $area.prop('autocomplete', 'password');

    var country = allCountries.filter(function (c) { return c.Code == selectedCountry; })[0] || {};
    var areasCount = country.AreasCount || 0;

    initLookup(areasCount, $countries, $postCode, $area, $city, $postalCodeAreasResults, selectFn, resetFn);

    $countries.bind('change', function (e) {

        $postCode.val('');
        $area.val('');
        $area.attr('value', '');

        if (typeof (selectFn) == 'function') {
            selectFn();
        }

        if (typeof (resetFn) == 'function') {
            resetFn();
        }

        areasCount = $('*:selected', $countries).data('areasCount') || 0;
        initLookup(areasCount, $countries, $postCode, $area, $city, $postalCodeAreasResults, selectFn, resetFn);

    });

};

var initLookup = function (areasCount, $countries, $postCode, $area, $city, $postalCodeAreasResults, selectFn, resetFn) {

    var bindLinks = function () {
        $("select", $postalCodeAreasResults).change(function (event) {
            event.preventDefault();

            var option = $(this).find("option:selected");
            var postCode = option.attr('data-post-code');
            var area = option.attr('data-area');
            var city = option.attr('data-city');

            $area.val(area);
            $area.attr('value', area);

            $city.val(city);
            $city.attr('value', city);

            //$postalCodeAreasResults.hide().empty();

            if (typeof (selectFn) == 'function') {
                selectFn(area, city, postCode, false);
            }
        });
    };

    var onAreaClick = function (e) {
        e.preventDefault();
        $postCode.focus().select();
    };

    var onAreaKeyDown = function (e) {
        e.preventDefault();
    };

    var onPostCodeKeyUp = $.debounce(500, function () {
        var countryCode = $countries.val();
        var postalCode = $postCode.val();
        if (!isNaN(postalCode) && ((countryCode === "GR" && postalCode.length == 5) || (countryCode === "CY" && postalCode.length == 4) || (countryCode === "CL" && postalCode.length == 7) || (countryCode === "HU" && postalCode.length == 4))) {
            if (postalCode.length > 0) {
                $postCode.closest('.form-row').addClass('x-loading');
                $postalCodeAreasResults.closest('.form-row').addClass('x-loading');

                $.ajax({
                    type: "POST",
                    dataType: 'json',
                    contentType: 'application/json; charset=UTF-8',
                    ContentType: 'application/json; charset=UTF-8',
                    url: LhApp.Function.Url.getServiceEndpoint('commonservice.svc/AreaLookUp'),
                    async: false,
                    data: JSON.stringify({ countryCode: countryCode, postalCode: postalCode }),
                    error: function (data) { },
                    success: function (data) {
                        if (data.d != "invalid_code") {
                            $postalCodeAreasResults.html(data.d);
                            $postalCodeAreasResults.addClass('select-wrapper');

                            if ($('select option', $postalCodeAreasResults).length == 1) {
                                hasMultipleAreas = false;

                                var option = $('select option', $postalCodeAreasResults);
                                var area = option.attr('data-area');
                                var city = option.attr('data-city');

                                $area.val(area);
                                $area.attr('value', area);

                                $city.val(city);
                                $city.attr('value', city);

                                $postalCodeAreasResults.hide().empty();

                                if (typeof (selectFn) == 'function') {
                                    selectFn(area, city, postalCode, false);
                                }
                            } else {
                                $area.val('');
                                if ($postalCodeAreasResults.parent().length > 0 && $postalCodeAreasResults.closest('.ng-hide').length <= 0 && checkoutConfig.scrollToAreas)
                                    $('html, body').animate({ scrollTop: $postalCodeAreasResults.parent().offset().top - 100 }, 600);

                                $postalCodeAreasResults.show();
                                bindLinks();

                                if (typeof (selectFn) == 'function') {
                                    selectFn('', '', postalCode, true);
                                }
                            }

                        } else {
                            $area.val('');
                            if (typeof (resetFn) == 'function') {
                                resetFn('', postalCode);
                            }

                            $postalCodeAreasResults.hide().empty();

                            if (typeof (selectFn) == 'function') {
                                selectFn('', '', postalCode, false);
                            }
                        }

                        $postCode.closest('.form-row').removeClass('x-loading');
                        $postalCodeAreasResults.closest('.form-row').removeClass('x-loading');
                    }
                });
            }
            else {
                $area.val('');

                if (typeof (resetFn) == 'function') {
                    resetFn('', postalCode);
                }
                $postalCodeAreasResults.closest('.form-row').removeClass('x-loading');
            }
        } else {
            $area.val('');

            if (typeof (resetFn) == 'function') {
                resetFn('', postalCode);
            }
            $postalCodeAreasResults.closest('.form-row').removeClass('x-loading');
            $postalCodeAreasResults.hide().empty();

            if (typeof (selectFn) == 'function') {
                selectFn('', '', postalCode, false);
            }
        }
    });

    if (areasCount > 1) {

        $area.addClass('disabled');
        $area.prop('oncontextmenu', 'return false;');
        $area.prop('onkeypress', 'return false;');

        $area.bind("onAreaClick", onAreaClick);
        $area.bind("onAreaKeyDown", onAreaKeyDown);

        $area.bind("contextmenu", function (e) {
            if ($area.is(":focus")) {
                $postCode.focus().select();
                return false;
            }
            return true;
        });

        $postCode.unbind("onPostCodeKeyUp");
        $postCode.bind("onPostCodeKeyUp", onPostCodeKeyUp);

    } else {

        $area.removeClass('disabled');
        $area.prop('oncontextmenu', '');
        $area.prop('onkeypress', '');

        $area.unbind("onAreaClick");
        $area.unbind("onAreaKeyDown");

        $area.unbind("contextmenu");
        $postCode.unbind("onPostCodeKeyUp");
    }

    $area.click(function (e) { $(this).trigger("onAreaClick", e); });
    $area.keydown(function (e) { $(this).trigger("onAreaKeyDown", e); });
    $postCode.keyup(function (e) { $(this).trigger("onPostCodeKeyUp", e); });

    if ($postCode.val() && $postCode.val().length > 0 && !$area.val()) $postCode.trigger('keyup');
};

var validateArea = function ($postCode, $area, $countries) {
    var result = true;
    var countryCode = $countries.val();
    var postalCode = $postCode.val();
    var areasCount = $('*:selected', $countries).data('areasCount') || 0;
    if (areasCount < 2) return result;
    if (!isNaN(postalCode)) {
        if ((countryCode === "GR" && postalCode.length == 5) || (countryCode === "CY" && postalCode.length == 4) || (countryCode === "CL" && postalCode.length == 7) || (countryCode === "HU" && postalCode.length == 4)) {
            if (postalCode.length > 0) {

                $.ajax({
                    type: "POST",
                    dataType: 'json',
                    contentType: 'application/json; charset=UTF-8',
                    ContentType: 'application/json; charset=UTF-8',
                    url: LhApp.Function.Url.getServiceEndpoint('commonservice.svc/AreaLookUp'),
                    async: false,
                    data: JSON.stringify({
                        countryCode: countryCode,
                        postalCode: postalCode
                    }),
                    error: function (data) { },
                    success: function (data) {
                        if (data.d != "invalid_code") {

                            var areasForPostalCode = $.parseHTML(data.d);

                            var areasPostalCodeMapping = [];

                            $('option', areasForPostalCode).each(function (index, elem) {
                                areasPostalCodeMapping.push($(elem).data('area') + '|' + $(elem).data('post-code'));
                            })

                            if ($.inArray($area.val().trim() + '|' + $postCode.val().trim(), areasPostalCodeMapping) === -1) {
                                result = false;
                            }

                        } else {
                            result = false;
                            $area.val('');
                        }
                    }
                });
            }
        } else {
            result = false;
        }
    } else {
        result = false;
    }

    return result;
};
